import { Result } from '@/classes'

export const translationsGetAPI = async (
  langId: string,
  params: {
    userId?: string
    eventId?: string
    postId?: string
  }
) => {
  const response: Result<{ translations: { [key: string]: string } }> = await fetchAPI('translations', { langId, ...params }, { method: 'POST' })

  return response
}
